import { FaustHooks } from "@faustwp/core";
import CustomSeedQuery from "./CustomSeedQuery";

const localePattern = /^\/(en|es)(\/|$)/;

export class LocaleRewrite {
  /**
   * @param {FaustHooks} hooks
   */
  apply(hooks: FaustHooks) {
    const { addFilter } = hooks;
    addFilter(
      "resolvedUrl",
      "rockhall",
      (resolvedUrl) => {
        if (resolvedUrl.match(localePattern)) return resolvedUrl.replace(localePattern, "/");
        return resolvedUrl;
      },
    );
    addFilter(
      "seedQueryDocumentNode",
      "rockhall",
      (seedQueryDocumentNode, context) => {
        return CustomSeedQuery;
      },
    );
  }
}